export const LEAP_PREFIX = '/api/leap';

/*
 * leap-middleware does not allow this site's origin, so a browser call to it is refused by
 * CORS. Calls from the browser therefore go through our own proxy at LEAP_PREFIX, which is
 * same origin and never preflighted.
 *
 * On the server - getServerSideProps and the API routes - there is no origin to check, so
 * leap is called directly. A relative URL would not resolve there in any case.
 */
export const leapUrl = (path) =>
  typeof window === 'undefined'
    ? `${process.env.LEAP_API_BASE_URL || process.env.NEXT_PUBLIC_LEAP_API_BASE_URL}${path}`
    : `${LEAP_PREFIX}${path}`;
